import React from "react";

import DonutEmpty from "../assets/skill_level_donut_empty.svg";
import DonutFull from "../assets/skill_level_donut_full.svg";
import DonutHalf from "../assets/skill_level_donut_half.svg";
import DonutQuarter from "../assets/skill_level_donut_quarter.svg";
import DonutThreeQuarters from "../assets/skill_level_donut_three_quarters.svg";
import { FULL, HALF, QUARTER, THREE_QUARTER } from "../constants/constants";

function SkillDonutRepresentation({
	representationLevel,
	size = 20,
}: {
	representationLevel?: number | string;
	size?: number;
}) {
	const ob = {
		minWidth: 	`${size}px`,
		minHeight: `${size}px`,
		borderRadius: "100%",
	};

	let src;
	let alt = "empty";
	switch (representationLevel) {
		case 1:
		case QUARTER:
			src = DonutQuarter;
			alt = "quarter";
			break;
		case 2:
		case HALF:
			src = DonutHalf;
			alt = "half";
			break;
		case 3:
		case THREE_QUARTER:
			src = DonutThreeQuarters;
			alt = "three-quarter";
			break;
		case 4:
		case FULL:
			src = DonutFull;
			alt = "full";
			break;
		default:
			src = DonutEmpty;
			alt = "empty";
			break;
	}

	return <img style={{ ...ob }} src={src} alt={alt} />;
}

export default SkillDonutRepresentation;
